// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "wrapper-3sDH_";
var _5 = "icon-3IAsl";
var _6 = "wrapper_outlined-1rAfz";
var _7 = "info-3FosF";
var _8 = "cancelButton-2hkNp";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "wrapper", _5 as "icon", _6 as "wrapper_outlined", _7 as "info", _8 as "cancelButton" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "wrapper": _4, "icon": _5, "wrapper_outlined": _6, "info": _7, "cancelButton": _8 }
